import {VeBoxEquipmentFilters} from "./data/models/VeBoxEquipmentFilters";
import {CENSUS_STATUS, CENSUS_STEP, JSONCensus} from "./data/models/JSONCensus";

export const isFilterOldEmpty = (filter: VeBoxEquipmentFilters): boolean => {
    return filter === undefined || Object.keys(filter).length === 0;
};

export const addVeBoxFilter = (
    filters: VeBoxEquipmentFilters,
    newFilter: VeBoxEquipmentFilters,
): VeBoxEquipmentFilters => {
    return {...filters, ...newFilter};
};

export const removeVeBoxFilter = (
    filters: VeBoxEquipmentFilters,
    filterToRemove: VeBoxEquipmentFilters,
): VeBoxEquipmentFilters => {
    const newFilters = {...filters};
    Object.keys(filterToRemove).forEach((key) => {
        if (
            typeof newFilters[key] === "object" &&
            typeof filterToRemove[key] === "object"
        ) {
            newFilters[key] = removeVeBoxFilter(newFilters[key], filterToRemove[key]);
        }
        if (
            newFilters[key] === filterToRemove[key] ||
            Object.keys(newFilters[key]).length === 0
        ) {
            delete newFilters[key];
        }
    });
    return newFilters;
};

export const replaceVeBoxFilter = (
    filters: VeBoxEquipmentFilters,
    filterToReplace: VeBoxEquipmentFilters,
) => {
    const newFilters = {...filters};
    Object.keys(filterToReplace).forEach((key) => {
        newFilters[key] = filterToReplace[key];
    });
    return newFilters;
};


export const isFirstStepCensus = (census: JSONCensus): boolean => {
    return census &&
        (census?.status === CENSUS_STATUS.CREATED && census?.step === CENSUS_STEP.EQUIPMENT_SELECTION);
}

export const isProcessingCensus = (census: JSONCensus): boolean => {
    return census &&
        (census?.status === CENSUS_STATUS.EQUIPMENT_SELECTED && census?.step === CENSUS_STEP.PROCESSING);
}


export const isSecondStepCensus = (census: JSONCensus): boolean => {
    return census && census?.status === CENSUS_STATUS.EQUIPMENT_SELECTED && census?.step === CENSUS_STEP.ACTIONS_REVIEW;
}